export default __webpack_public_path__ + "static/media/account.86b15f75.svg";